var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.options),function(o,key){return _c('div',{key:key,staticClass:"mt-1 mb-3 ml-2 pt-2 pb-2 pr-4 pl-4 bg-graylight rounded-lg border d-inline-block w-fit cursor-pointer",on:{"click":function($event){return _vm.$emit('select', o)}}},[_vm._v(" "+_vm._s(o.content)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }